"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NotFound;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _core = require("@lingui/core");

var _Page = require("../../components/Layout/Page");

var _blocks = require("@bueno/blocks");

const StyledContentWrap = (0, _styledComponents.default)(_Page.ContentWrap)`
  padding: ${_blocks.spacing.extraLoose};
`;
const LinksList = _styledComponents.default.div`
  li {
    margin-bottom: ${_blocks.spacing.tight};
  }
`;

function NotFound() {
  return /*#__PURE__*/_react.default.createElement(_Page.Wrap, null, /*#__PURE__*/_react.default.createElement(StyledContentWrap, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginBottom: `${_blocks.spacing.loose}`
    }
  }, /*#__PURE__*/_react.default.createElement(_blocks.DisplayMedium, null, _core.i18n._({
    id: 'not_found.page_not_available',
    message: `Page not available. The page requested no longer exists or isn't accessible to you.`
  }))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginBottom: `${_blocks.spacing.tight}`
    }
  }, /*#__PURE__*/_react.default.createElement(_blocks.DisplaySmall, null, _core.i18n._({
    id: 'not_found.related_links',
    message: `Related links`
  }))), /*#__PURE__*/_react.default.createElement(LinksList, null, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "/analysis/insights"
  }, _core.i18n._({
    id: 'app_chrome.insights',
    message: `Insights`
  }))), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "/actions"
  }, _core.i18n._({
    id: 'app_chrome.actions',
    message: `Actions`
  }))), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "/reports"
  }, _core.i18n._({
    id: 'app_chrome.reports',
    message: `Reports`
  })))))));
}

module.exports = exports.default;